/**
 * cbpAnimatedHeader.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
var cbpAnimatedHeader = (function() {

    var docElem = document.documentElement,
        header = document.querySelector( '.navbar-default' ),
        didScroll = false,
        changeHeaderOn = 200;

    function init() {
        window.addEventListener( 'scroll', function( event ) {
            if( !didScroll ) {
                didScroll = true;
                setTimeout( scrollPage, 250 );
            }
        }, false );
    }

    function scrollPage() {
        var sy = scrollY();
        if ( sy >= changeHeaderOn ) {
            classie.add( header, 'navbar-scroll' );
            $('#brandlogo').attr("src", "assets/images/logo2.png");
        }
        else {
            classie.remove( header, 'navbar-scroll' );
            $('#brandlogo').attr("src", "assets/images/logo.png");
        }
        didScroll = false;
    }

    
    

    function scrollY() {
        return window.pageYOffset || docElem.scrollTop;
    }

    init();

})();

    
$( '#menubutton' ).click(function() {
    if ($(".navbar-clicked")[0])
    {
        $('.navbar-fixed-top').removeClass("navbar-clicked");
    }
    else
    {
        $('.navbar-fixed-top').addClass("navbar-clicked");
    }    

});


$(document).on('click','.navbar-collapse.in',function(e) {
    if( $(e.target).is('a') && $(e.target).attr('class') != 'dropdown-toggle' ) {
        $(this).collapse('hide');
    }
});